import SoundVars from "../../src/const/SoundVars";
import SoundController from "../../src/utils/SoundController";
import GameModel from "../model/GameModel";
import RealityCheckModel from "../model/RealityCheckModel";
import FullscreenUtils from "../utils/FullscreenUtils";
import Layout from "../utils/Layout";
import { State } from "./State";
import App from "../../../core/src/App";
import PreloadView from "../../../core/src/views/PreloadView";
import GameLoader from "../../../core/src/utils/GameLoader";
import Locale from "../../../core/src/utils/Locale";
import gameModel from "../model/GameModel";
// TODO this should not be imported here
import GameEvents from "../const/GameEvents";
import ViewManager from "../../../core/src/utils/ViewManager";
import { TweenMax } from "gsap";
import UIController from "../../src/ui/UIController";
import { DefaultLayers } from "../../src/utils/Layers";
import ReelGroup from "../../src/views/ReelGroup";
import InstanceFactory from "../factories/InstanceFactory";
import PointerEvents from "../const/PointerEvents";

import Reel from "../../src/views/Reel";
import SpinModel from "../model/SpinModel";
import loader = PIXI.loader;
import { UpdateUICommand } from "../commands/GameCommands";
import ErrorModel from "../model/ErrorModel";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import { UIStates } from "../ui/UIStates";

export default class PreloadState extends State {
  protected preloadView: PreloadView;
  public enter() {
    super.enter();
    GameLoader.loadLocalization(GameLoader.config.localizedContent, () => {
      // localization should be loaded first (could be used in preloader)
      GameLoader.loadAssets(
        GameLoader.config.initialResources,
        this.bootComplete.bind(this)
      );
    });
  }

  public bootComplete(loader: PIXI.loaders.Loader) {
    if (GameModel.isMobile() && !(GameModel.urlParams.fullscreen == "false")) {
      this.createHandandArrow();
    }

    Locale.addSource(loader.resources.localization.data);
    this.preloadView = InstanceFactory.getClass("PreloadView") as PreloadView;
    if (ViewManager.getDomLayer(DefaultLayers.Background)) {
      ViewManager.getDomLayer(DefaultLayers.Background).playDefault();
    }

    GameLoader.loadAssets(
      GameLoader.config.mainResources,
      // this.preloadComplete.bind(this),
      this.loadMusic.bind(this),
      this.preloadView.handleProgress.bind(this.preloadView)
    );
  }

  public preloadComplete() {
    App.assets.onResourcesLoaded();
    const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
    const scene = preloadLayer.setScene("start");
    scene.interactive = true;
    scene.on(PointerEvents.DOWN, () => {
      preloadLayer.clear();
      if (ErrorModel.hasError()) {
        this.exit();
      } else {
        this.buildViews();
        this.startGame();
      }
    });

    this.initSoundLoading();

    // TODO destroy preloader from view manager
  }

  protected setupReels() {
    const reelGroup = InstanceFactory.getClass("ReelGroup", true) as ReelGroup;
    ViewManager.getLayer(DefaultLayers.Reels)
      .getCurrentScene()
      .addSubView(reelGroup, "ReelGroup", "reels");
    reelGroup.create(
      ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene()
    );

  }

  protected buildViews() {
    ViewManager.playDefault();
    this.setupReels();
  }

  // MUST run buildViews first
  protected startGame() {

    // Create the UI controller
    UIController.create();
    UIController.setState(UIStates.HIDDEN);
    // Update the bet bar
    CommandManager.execute(Commands.UPDATE_UI);

    // Update the info bar
    CommandManager.execute(Commands.UPDATE_INFO_BAR);

    this.startMusicPlayback();

    this.exit();
  }

  protected initSoundLoading() {
    SoundController.musicVolume = App.config.maxMusicVolume || 1;
    GameLoader.loadSoundAssets(GameLoader.config.sounds, () => {
      SoundController.loadSounds(GameLoader.config.sounds);
      console.log("Sound resources loaded");
      SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
      if (SoundController.musicRequested) {
        SoundController.musicRequested = false;
        SoundController.playMusic(SoundVars.MUSIC_MAIN);
      }
    });
  }

  protected loadMusic() {
    if (GameLoader.config.music) {
      GameLoader.loadSoundAssets(GameLoader.config.music, () => {
        SoundController.loadSounds(GameLoader.config.music);
        this.preloadComplete();
      });
    } else {
      this.preloadComplete();
    }
  }

  protected startMusicPlayback() {
    if (SoundController.soundsLoaded) {
      SoundController.playMusic(SoundVars.MUSIC_MAIN);
    } else {
      SoundController.musicRequested = true;
    }
  }

  protected createHandandArrow() {
    FullscreenUtils.appendHandImages();
  }
}
